import { ILandingPlanning } from 'partner360/models/landing/ILandingPlanning'
import { ILandingProcessedPlanningFetched } from 'partner360/models/landing/ILandingProcessedPlanningFetched'
import { LandingCategory } from 'partner360/models/landing/LandingCategory'
import { LandingOffering } from 'partner360/models/landing/LandingOffering'
import { LandingStatus } from 'partner360/models/landing/LandingStatus'

interface IGetOfferings {
  selectedCategory: LandingCategory
  selectedPlanning: ILandingPlanning
  processedPlannings: ILandingProcessedPlanningFetched[]
  selectedStatus: LandingStatus
}
export const getOfferings = ({
  selectedPlanning,
  selectedCategory,
  selectedStatus,
  processedPlannings,
}: IGetOfferings) => {
  const offeringsFromPlanning = selectedPlanning.AllCategories.find(
    (el) => el.Category === selectedCategory
  )

  if (!offeringsFromPlanning) {
    return []
  }

  const offerings: LandingOffering[] = [
    LandingOffering.Total,
    ...Array.from(
      new Set(
        processedPlannings
          .filter((el) => el.category === selectedCategory && el.status === selectedStatus)
          .map((el) => el.offering)
      )
    ),
  ]
  return offeringsFromPlanning.Offerings.filter((el) => offerings.includes(el.Offering))
}
